import { type ReactNode } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { defaultQueryFn } from "@/src/queries/defaultQuery";

// SSR follow-up (AJOC2B-1752): once React Router v7 framework-mode loaders
// land, move `new QueryClient(...)` creation into a `useState(() => ...)` hook
// inside this component so each SSR request gets its own client, and wrap
// children with `<HydrationBoundary state={...}>` using loader-dehydrated state.
// Also set staleTime there once hydration is wired up.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false
    }
  }
});

export const ReactQueryProvider = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
